<template>
    <div class="col-12 col-sm-6 col-xl-4" >
        <a :href="marketLink" class="one__shop_block d-flex flex-column">
            <div class="shop__block_logo"><img :src="market.logo" alt=""></div>
            <div class="shop__block_text">{{ shortDescription }}</div>
            <div class="shop__block_desc" >{{ catchphrase }}</div>
        </a>
    </div>
</template>

<script>
export default {
    name: "ShopItem",
    props: {
        market:{
            type: [Object,Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
    },
    data() {
        return {

        }
    },
    methods: {
    },
    computed:{
        catchphrase(){
            return this.market.catchphrase ?? '';
        },
        shortDescription(){
            return this.market.short_description ?? '';
        },
        marketLink(){
            if(typeof this.market.slug !=='undefined' && this.market.slug !==null){
                return '/'+this.lng+'/shops/'+ this.market.slug;
            }
           return '#';
        }

    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
